module.exports = __webpack_public_path__ + "static/media/bg-image-58.2a45e00b.jpg";